import { useState } from 'react';
import { NewsWidget, dashboardWidgetRegistry, useActiveMobileWidget } from '@/core/widgets/export';
import { RequirePermissions, Permissions } from '@/core/permissions/export';
import { ChatDrawer } from '@/core/chat/export';
import { MOBILE_SIDE_PANEL_BAR_HEIGHT_PX } from '@/core/deep-dive/export';
import SingleWidgetHost from '@/app/dashboard/components/single-widget-host';
import MobileTopbar, { MOBILE_TOPBAR_FALLBACK_HEIGHT_PX } from './mobile-topbar';
import MobileHamburgerMenu from './mobile-hamburger-menu';
import MobileWidgetSelector from './mobile-widget-selector';

type Overlay = 'none' | 'menu' | 'widgets';

export default function MobileDashboardShell({
  notificationSoundOn,
  setNotificationSoundOn,
}: {
  notificationSoundOn: boolean;
  setNotificationSoundOn: (on: boolean) => void;
}) {
  const [overlay, setOverlay] = useState<Overlay>('none');
  const [topbarHeight, setTopbarHeight] = useState(MOBILE_TOPBAR_FALLBACK_HEIGHT_PX);
  const { activeMobileWidgetId, setActiveMobileWidgetId } = useActiveMobileWidget();

  const handleActiveWidgetChange = (widget: NewsWidget) => setActiveMobileWidgetId(widget.id);

  return (
    <div className={'vh-100 d-flex flex-column'}>
      <MobileTopbar onOpenMenu={() => setOverlay('menu')} onHeightChange={setTopbarHeight} />

      <div
        className="flex-grow-1 overflow-hidden"
        style={{
          paddingTop: topbarHeight,
          paddingBottom: MOBILE_SIDE_PANEL_BAR_HEIGHT_PX,
        }}
      >
        <SingleWidgetHost
          registry={dashboardWidgetRegistry}
          headerVariant="title"
          includeDynamicWidgets
          onActiveWidgetChange={handleActiveWidgetChange}
          headerControls={<></>}
        />
      </div>

      <RequirePermissions allow={Permissions.ALPHA_ACCESS_CHAT}>
        <ChatDrawer />
      </RequirePermissions>

      {overlay === 'menu' && (
        <MobileHamburgerMenu
          notificationSoundOn={notificationSoundOn}
          setNotificationSoundOn={setNotificationSoundOn}
          activeWidgetContent={
            activeMobileWidgetId
              ? dashboardWidgetRegistry.getById(activeMobileWidgetId)?.headerPanel
              : undefined
          }
          onOpenWidgetSelector={() => setOverlay('widgets')}
          onClose={() => setOverlay('none')}
        />
      )}

      {overlay === 'widgets' && (
        <MobileWidgetSelector
          activeWidgetId={activeMobileWidgetId}
          onBack={() => setOverlay('menu')}
          onClose={() => setOverlay('none')}
        />
      )}
    </div>
  );
}
